"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
var shared_1 = require("@cian/peperrors/shared");
var Response_1 = require("./Response");
var RESPONSE_TYPE_MAP = {
    json: 'text',
    string: 'text',
    binary: 'arraybuffer',
};
var Request = /** @class */ (function () {
    function Request(params) {
        this.isDestroyed = false;
        this.requestConfig = params.requestConfig;
        this.timeout = params.timeout;
        this.requestServerName = params.requestServerName || params.requestConfig.url.host;
    }
    Request.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.makeRequestPromise()];
            });
        });
    };
    Request.prototype.makeRequestPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a = _this.requestConfig, url = _a.url, withCredentials = _a.withCredentials, method = _a.method, headers = _a.headers, body = _a.body, _b = _a.responseType, responseType = _b === void 0 ? 'string' : _b;
            var stringUri = url.toString();
            var xhrResponseType = RESPONSE_TYPE_MAP[responseType];
            _this.reject = reject;
            _this.request = new XMLHttpRequest();
            _this.request.addEventListener('load', function () {
                var responseData = Response_1.nullBodyStatuses.includes(_this.request.status)
                    ? null
                    : responseType === 'binary'
                        ? _this.request.response
                        : _this.request.responseText;
                var response = new Response(responseData, {
                    status: _this.request.status,
                    statusText: _this.request.statusText,
                });
                resolve(new Response_1.Response({
                    reqConfig: _this.requestConfig,
                    rawHeaders: _this.request.getAllResponseHeaders(),
                    response: response,
                    statusCode: _this.request.status,
                }));
            });
            _this.request.addEventListener('timeout', function () {
                reject(new shared_1.HttpTimeoutError("Microservice ".concat(_this.requestServerName, " api ").concat(stringUri, " not answers in ").concat(_this.timeout, " milliseconds"), "http-api.request-timeout.".concat(_this.requestServerName)));
            });
            _this.request.addEventListener('error', function () {
                return reject(new shared_1.UnknownError({
                    message: "Microservice ".concat(_this.requestServerName, " api ").concat(stringUri, " request error"),
                    domain: "http-api.request-error.".concat(_this.requestServerName),
                }));
            });
            _this.request.open(method, stringUri, true);
            _this.request.timeout = _this.timeout;
            _this.request.withCredentials = withCredentials;
            headers.toArray().forEach(function (_a) {
                var _b = __read(_a, 2), name = _b[0], value = _b[1];
                return _this.request.setRequestHeader(name, value);
            });
            _this.request.responseType = xhrResponseType;
            // TODO: null - это старый код, необходимо проверить, что можно без него
            _this.request.send(body || null);
        });
    };
    Request.prototype.destroy = function (err) {
        if (this.request) {
            this.isDestroyed = true;
            this.request.abort();
            this.reject(err);
        }
    };
    return Request;
}());
exports.Request = Request;
//# sourceMappingURL=Request.js.map